module.exports = __webpack_public_path__ + "img/arrow-right-white.0e9065ea.svg";